<template>
    <div class="page-content" id="identification-list">
        <Titlebar :incrustation="'fa-id-card'">
            <h1>{{ $t('identification.titles.list') }}</h1>
        </Titlebar>
        <LoadingMini ref="loading"></LoadingMini>
        <UiCard>
            <div class="alert alert-info mb-4">
                <p v-html="$t('identification.description.content', {univers: Utils.getApplicationName()})"></p>
            </div>
            <SuperTable 
                ref="tableIdentifications" 
                :tableColumns="tableColumns" 
                :tableData="tableData"
                @sort="handleSort" 
                @filter="handleFilter" 
                @delete="handleDelete"
                @copy="handleCopy"
            />
        </UiCard>
        <Toolbar>
            <div class="row">
                <div class="col">
                    <Btn class="primary" v-can="'beepiz-add-identifications'">
                        <router-link to="/parameters/identifications/new" tag="span"><i
                                class="fa fa-plus"></i><span>{{ $t('identification.btns.add') }}</span>
                        </router-link>
                    </Btn>
                </div>
                <div class="col center">
                    <Pagination ref="pagination" @change="handlePagination"></Pagination>
                </div>
                <div class="col">
                </div>
            </div>
        </Toolbar>
    </div>
</template>

<script>

    import axios from 'axios';
    import API from '@/services/API.js';
    import Auth from '@/services/auth.js'
    import Utils from '@/services/utils.js'
    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import UiCard from "@/components/ui/Card";
    import Pagination from "@/components/ui/Pagination";
    import SuperTable from "@/components/ui/Table";
    import Globals from '@/services/globals.js';

    import traductions from '@/services/traductions.js'

    import LoadingMini from '@/components/ui/LoadingMini';

    import UserRenderer from "@/components/identifications/TableRowUserRenderer";
    import {useDvFlag, useDvFlagAccess} from "../../services/featureFlag";

    export default {
        name: 'IdentificationsList',
        components: {
            Titlebar,
            Toolbar,
            Btn,
            UiCard,
            Pagination,
            SuperTable,
            LoadingMini
        },
        computed: {
          Utils() {
            return Utils
          },
        },
        data: () => ({
            count: 0,
            languages: null,
            config: {
                perpage: Globals.perPage,
                fields: [],
                page: 1,
                filter: {
                    like: [],
                    equals: []
                },
                sort: []
            },
            tableColumns: {
                global: {
                    sortable: false,
                    noItemsMsg: window.V.$i18n.t('identification.emptyTable')
                },
                columns: [
                    {
                        key: 'name',
                        label: Utils.t('identification.name'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: true,
                        filter: {
                            type: 'text'
                        },
                        width: '25%',
                        renderer: UserRenderer
                    },
                    {
                        key: 'serial',
                        label: Utils.t('identification.serial'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: true,
                        filter: {
                            type: 'text'
                        },
                        width: '25%',
                        renderer: (item) => {
                            return `<span class="text-mono">${item.serial}</span>`
                        }
                    },
                    {
                        key: 'language',
                        label: Utils.t('identification.language'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: true,
                        filter: {
                            type: 'text'
                        },
                        width: '10%',
                        renderer: (item) => {

                            if(item.language != null){

                                var lang = item.language.split('_')[1]

                                if(lang) {
                                  return '<div class="identification-flag">' + require('../../assets/img/flags/4x3/' + lang.toLowerCase() + '.svg') + '</div>'
                                }
                                return ''
                            }

                            return ''
                        }
                    },
                    {
                        key: 'comment',
                        label: Utils.t('identification.comment'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: false,
                        filter: {
                            type: 'text'
                        },
                        width: '30%',
                        className: 'comment',
                        showTooltip:true,
                        tooltipTitle:Utils.t('identification.tooltip.title'),
                        tooltipContent:Utils.t('identification.tooltip.content')
                    }
                ],
                rowActions: {
                    width: '15%',
                    actions: [
                        {
                            label: Utils.t('global.copy'),
                            class: 'fa fa-copy',
                            event: 'copy'
                        },
                        {
                            label: Utils.t('global.delete'),
                            class: 'fa fa-trash',
                            event: 'delete'
                        }
                    ]
                }
            },
            tableData: []
        }),

        methods: {
            renderLangs: function(item){

            },
            handlePagination: function (page) {
                this.config.page = page;
                this.loadData();
            },
            handleSort: function () {
                this.config.sort = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeSort) {
                        this.config.sort.push(col.activeSort + col.key);
                    }
                }
                this.loadData();
            },
            handleFilter: function () {
                this.config.page = 1;
                this.config.filter.like = [];
                this.config.filter.equals = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeFilter != '') {
                        if (col.filter && col.filter.type == 'text') {
                            this.config.filter.like.push(col.key + ':' + col.activeFilter);
                        }
                        if (col.filter && col.filter.type == 'list') {
                            this.config.filter.equals.push(col.key + ':' + col.activeFilter);
                        }
                    }
                }
                this.loadData();
            },
            handleCopy: function (item) {
                window.V._router.push('/parameters/identifications/' + item.id + '/copy');
            },
            handleDelete: function (item) {
                window.Vfc.$refs.confirm.show({
                    title: Utils.t('global.deleteModalTitle'),
                    content: Utils.t('global.deleteModalContent'),
                    callbackYes: () => {
                        axios.delete(API.route(API.endpoints.identifications.delete, {id: item.id}))
                            .then(response => {
                                if(this.tableData.length == 1 && this.config.page > 1){
                                    this.config.page--;
                                }
                                this.loadData();
                            })
                            .catch(e => {
                                this.$refs.loading.hide();
                            });
                    }
                });
            },
            loadData: function () {
                this.$refs.loading.show();
                axios.get(API.endpoints.identifications.index + API.constructQueryParams(this.config))
                    .then(response => {
                        this.tableData = response.data.data;
                        this.count = response.data.meta.pagination.total;
                        this.$refs.pagination.update(response.data.meta.pagination);
                        this.$refs.loading.hide();
                        window.Vfc.$refs.loading.hide();
                    })
                    .catch(e => {
                        this.$refs.loading.hide();
                        window.Vfc.$refs.loading.hide();
                    })
            }
        },

        watch: {
            tableData: {
                handler: function (val) {
                }
            }
        },

        mounted(){
          const flag = useDvFlag('beepiz-identifications-can:read');
          if (!flag.access && flag.fallback==="no_plan") {
            this.$router.push({ name: 'AccessDenied', params: { slug: "identifications"} })
          }
          else if (!flag.access && flag.fallback==="no_role") {
            this.$router.push({ name: 'AccessDenied', params: { slug: "identifications_no_role"} })
          }
          else {
                if(!useDvFlagAccess('beepiz-identifications-can:delete')){
                    this.tableColumns.rowActions.actions.splice(1,1);
                }
    
                if(!useDvFlagAccess('beepiz-identifications-can:create')){
                    this.tableColumns.rowActions.actions.splice(0,1);
                }
    
                var lsLocale = window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_LOCALE');
                if(!lsLocale){
                    lsLocale = 'fr'
                }
                this.languages = traductions[lsLocale].languages
    
                this.loadData(1);
            }
        }
    }
</script>

<style lang="scss">
.identification-flag {
  width: 30px;
}
</style>
